// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container-repasse .modal-content {
  width: 80vw;
  height: 80vh;
  margin-bottom: 230px;
  margin-bottom: 130px;
}
.modal-body-repasse {
  height: 400px;
  width: 100%;
}

.modal-body-repasse section {
  height: 100%;
}
.list-medical {
  height: 140px;
  border: 1px solid red;
}
`, "",{"version":3,"sources":["webpack://./src/views/componentCss/ReportRevenueDistribuitionAdd.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[".modal-container-repasse .modal-content {\n  width: 80vw;\n  height: 80vh;\n  margin-bottom: 230px;\n  margin-bottom: 130px;\n}\n.modal-body-repasse {\n  height: 400px;\n  width: 100%;\n}\n\n.modal-body-repasse section {\n  height: 100%;\n}\n.list-medical {\n  height: 140px;\n  border: 1px solid red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
